import React from 'react';

import {LabAutomationFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isConnectFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {instrumentGatewaysURL} from 'instruments/instrument-gateways/InstrumentGatewayDAO';
import {ASSAY_SCHEMA_SIDEBAR_SECTIONS, ASSAY_TYPES} from 'results/assay-schemas/AssaySchemaConstants';
import * as AssaySchemaDAO from 'results/assay-schemas/AssaySchemaDAO';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';

import EmptySidebarIcon from './EmptySidebarIcon';
import {SettingsSection, Section} from './SidebarConstants';
import SidebarItem from './SidebarItem';

interface RunSchemaSettingsProps {
  section: SettingsSection;
}

export default function RunSchemaSettings(props: RunSchemaSettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Automation Schemas</div>
      {isConnectFeatureEnabled({feature: LabAutomationFeature.LAB_AUTOMATION_ADMIN}) && (
        <SidebarItem
          active={props.section === Section.INSTRUMENT_GATEWAYS}
          icon={<EmptySidebarIcon />}
          name="Instrument gateways"
          link={instrumentGatewaysURL()}
          dataTestAttrsKey="instrumentGatewayList"
        />
      )}
      <SidebarItem
        active={props.section === ASSAY_SCHEMA_SIDEBAR_SECTIONS[ASSAY_TYPES.ASSAY_RUN]}
        icon={<EmptySidebarIcon />}
        name={`${MODEL_NAMES.Run} schemas`}
        link={AssaySchemaDAO.assaySchemasURL(ASSAY_TYPES.ASSAY_RUN)}
        dataTestAttrsKey="runSchemaList"
      />
    </div>
  );
}
